import GridLoader from "react-spinners/GridLoader";

export default function GridLoadingScreen({ className }: any) {
  return (
    <div className={className}>
      <GridLoader color='#3692d6' size={25} />
    </div>
  );
}
